<template>

  <div class="all">
    <headercon></headercon>
    <button class="button"
            @click="go">
      返 &nbsp; 回
    </button>
  </div>
</template>

<script>
import headercon from './header'
export default {
  components: {
    headercon
  },
  data () {
    return {
      img: require('../assets/componylogo.png'),

      text: '首页',
      text1: '产品与服务',
      text2: '企业动态',
      text3: '资质荣誉',
      text4: '关于我们'

    }
  },
  methods: {

    go () {
      this.$router.push({ path: '/recruit' })
    }

  }
}
</script>

<style scoped lang="less">
.all {
  background: url("../assets/toudi.png");
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
  min-width: 1199px;
  /deep/ .li5 {
    list-style-type: none;
    float: left;
    border-radius: 25px;
    background: #fff;
    width: 100px;
    height: 30px;
    text-decoration: none;
    text-align: center;
    line-height: 30px;
    a {
      color: #757575;
      text-decoration: none;
    }
  }
}
@media only screen and (min-width: 1781px) {
  .button {
    position: absolute;
    bottom: 15%;
    margin-left: 76%;
    width: 200px;
    height: 60px;
    text-align: center;
    line-height: 10px;
    background: rgb(10, 158, 184);
    border: none;
    color: white;
    font-size: 30px;
  }
}
@media only screen and (min-width: 1601px) and (max-width: 1780px) {
  .button {
    position: absolute;
    bottom: 15%;
    margin-left: 79%;
    width: 200px;
    height: 60px;
    text-align: center;
    line-height: 10px;
    background: rgb(10, 158, 184);
    border: none;
    color: white;
    font-size: 30px;
  }
}
@media only screen and (min-width: 1421px) and (max-width: 1600px) {
  .button {
    position: absolute;
    bottom: 15%;
    margin-left: 79%;
    width: 200px;
    height: 60px;
    text-align: center;
    line-height: 10px;
    background: rgb(10, 158, 184);
    border: none;
    color: white;
    font-size: 30px;
  }
}
@media only screen and (min-width: 1200px) and (max-width: 1420px) {
  .button {
    position: absolute;
    bottom: 15%;
    margin-left: 78%;
    width: 150px;
    height: 50px;
    text-align: center;
    line-height: 10px;
    background: rgb(10, 158, 184);
    border: none;
    color: white;
    font-size: 30px;
  }
}
@media only screen and (max-width: 1200px) {
  .button {
    position: absolute;
    bottom: 15%;
    margin-left: 920px;
    width: 150px;
    height: 50px;
    text-align: center;
    line-height: 10px;
    background: rgb(10, 158, 184);
    border: none;
    color: white;
    font-size: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/toudi.vue